import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
// Styles before any component: feature `*.module.css` files refine the global
// primitives and rely on loading after them.
import '@sciolingo/renderer/styles.css'
import './styles/tokens.css'
import './styles/global.css'
import { queryClient } from './app/queryClient'
import { router } from './app/router'
import { AuthProvider } from './features/auth/AuthProvider'
import { installPushBridge } from './features/push/push'
import { requestPersistence } from './offline/storage'

// §10.4: on first run, and the result is logged rather than assumed.
void requestPersistence()

// Notification deep links: installed at module scope, before React renders. A cold-start
// notification tap fires before any component exists, so a listener attached in
// an effect is attached too late and the tap is lost.
installPushBridge()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
